import React, { useEffect, useState } from "react";
import {
  toAbsoluteUrl,
  toasterrormsg,
  toastsuccessmsg,
} from "../../helpers/Reusable";
import { FaMagnifyingGlass } from "react-icons/fa6";
import { apiHeader, getData, postData } from "../../helpers/ApiHelper";
import { IoClose } from "react-icons/io5";
import * as Yup from "yup";
import { useFormik } from "formik";
import ClipLoader from "react-spinners/ClipLoader";
import { Helmet } from "react-helmet-async";

// Formik InitialValues
const initialValues = {
  email: "",
  fullName: "",
  comment: "",
  status: "0",
};

// Fromik Validation Schema
const schema = Yup.object().shape({
  email: Yup.string()
    .trim()
    .required("Email is required")
    .matches(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      "Email is not valid"
    ),
  fullName: Yup.string().trim().required("Full Name is required"),
  comment: Yup.string().trim().required("Comment is required"),
});

const ViewArticleTwo = () => {
  const [searchMenu, setSearchMenu] = useState("GST & Customs");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const shareLink = `https://web.xpertlab.com/naruto/gcc-law-help/viewarticle2`;

  const formik = useFormik({
    initialValues,
    validationSchema: schema,
    onSubmit: async (values, { resetForm }) => {},
  });

  const openModal = () => {
    document.body.style.overflowY = "hidden";
    setIsModalOpen(true);
  };
  const closeModal = () => {
    document.body.style.overflowY = "";
    setIsModalOpen(false);
    formik.resetForm();
  };

  const searchList = [
    {
      name: "Account",
    },
    {
      name: "FEMA & Banking",
    },
    {
      name: "Advisory",
    },
    {
      name: "GST & Customs",
    },
    {
      name: "Finance Act",
    },
    {
      name: "Company Law",
    },
  ];
  return (
    <>
      <Helmet>
        {/* Open Graph Meta Tags */}
        <meta property="og:title" content="GCC Law Help Article" />
        <meta
          property="og:description"
          content="Read this insightful legal article on GCC Law Help."
        />
        <meta property="og:url" content={shareLink} />
        <meta property="og:type" content="article" />
      </Helmet>
      {isModalOpen === true && (
        <>
          <div
            onClick={closeModal}
            className={`w-full fixed top-0 left-0 z-[9999] h-screen overflow-x-hidden overflow-y-auto bg-form getintouch`}
          >
            <div
              onClick={(e) => e.stopPropagation()} // Prevents click inside modal from closing it
              className="w-[90%] md:w-[80%] lg:w-[60%] xl:container p-[4%] lg:p-[2%] mx-auto my-[5%] lg:my-0 relative top-[10%] lg:top-1/2 transform lg:-translate-y-1/2 form-box"
            >
              <div className="flex items-center justify-between">
                <h1 className="mb-[3%] hanson">Leave a reply</h1>
                <IoClose
                  onClick={closeModal}
                  className="w-[3rem] h-[3rem] cursor-pointer"
                />
              </div>
              <div className="">
                <form onSubmit={formik.handleSubmit}>
                  <div className="w-full grid lg:grid-cols-2 gap-[2rem] mb-[7rem]">
                    <div className="w-full flex flex-col">
                      <label
                        htmlFor=""
                        className="w-full form-input-label required mb-4"
                      >
                        Email
                      </label>
                      <input
                        className="w-full form-input"
                        type="email"
                        placeholder="Enter Email"
                        id="email"
                        value={formik.values.email}
                        onChange={formik.handleChange}
                      />
                      {formik.touched.email && formik.errors.email && (
                        <div className="mt-4 error-msg">
                          <div className="">{formik.errors.email}</div>
                        </div>
                      )}
                    </div>
                    <div className="w-full flex flex-col">
                      <label
                        htmlFor=""
                        className="w-full form-input-label required mb-4"
                      >
                        Full Name
                      </label>
                      <input
                        className="w-full form-input"
                        type="text"
                        placeholder="Enter Full Name"
                        id="fullName"
                        value={formik.values.fullName}
                        onChange={formik.handleChange}
                      />
                      {formik.touched.fullName && formik.errors.fullName && (
                        <div className="mt-4 error-msg">
                          <div className="">{formik.errors.fullName}</div>
                        </div>
                      )}
                    </div>
                    <div className="w-full lg:col-span-2 flex flex-col">
                      <label
                        htmlFor=""
                        className="w-full form-input-label mb-4 required"
                      >
                        Comment
                      </label>
                      <textarea
                        placeholder="Enter Comment"
                        type="text"
                        className="w-full form-input"
                        id="comment"
                        value={formik.values.comment}
                        onChange={formik.handleChange}
                        rows={3}
                      />
                      {formik.touched.comment && formik.errors.comment && (
                        <div className="mt-4 error-msg">
                          <div className="">{formik.errors.comment}</div>
                        </div>
                      )}
                    </div>
                    <div className="w-full lg:col-span-2">
                      <label
                        htmlFor="status"
                        className="flex items-start gap-5 cursor-pointer"
                      >
                        <input
                          type="checkbox"
                          id="status"
                          name="status"
                          checked={formik.values.status == "1"}
                          onChange={(e) =>
                            formik.setFieldValue(
                              "status",
                              e.target.checked ? "1" : "0"
                            )
                          }
                          className={`w-[2rem] h-[2rem] accent-green-600`}
                        />
                        <span className="form-input-label">
                          Save my name, email, and website in this browser for
                          the next time i comment.
                        </span>
                      </label>
                    </div>
                  </div>
                  <div className="w-full justify-center gap-5 flex">
                    <button
                      type="submit"
                      className="btn-submit"
                      disabled={loading}
                    >
                      {!loading && <>Post comment</>}
                      {loading && (
                        <div className="flex items-center gap-3">
                          <span className="" style={{ display: "block" }}>
                            Please wait...{" "}
                          </span>
                          <ClipLoader
                            color={"#ffffff"}
                            loading={loading}
                            size={20}
                            aria-label="Loading Spinner"
                            data-testid="loader"
                          />
                        </div>
                      )}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </>
      )}
      <div className="w-full p-[5%] bg-yellow">
        <div className="w-full mb-[3%] md:mb-[2%]">
          <h1 className="hanson text-center mb-[1%] heading">Article</h1>
          <img
            className="mb-[2%] mx-auto"
            src={toAbsoluteUrl("media/img/titledesign/t-yellow.svg")}
            alt=""
          />
        </div>
        <div className="w-full mb-[5%] flex gap-10 lg:flex-row flex-col section-view-article">
          <div className="sva-part1">
            <div className="w-full pb-[2%] mb-[2%] svap1-part1">
              <h1 className="xl:w-[70%] mb-[2%] svap1p1-title">
                Metronic Admin - How To Get Started Tutorial. Create a
                customizable SaaS Based applications and solutions
              </h1>
              <div className="mb-[2%] flex flex-col gap-2 sm:gap-0 sm:flex-row md:items-center">
                <div className="w-max flex items-center">
                  <div className="w-max leading-none flex items-center pr-[1rem] svap1p1-details">
                    <h1 className="w-max svap1p1d-t1">5 mins read</h1>
                  </div>
                  <div className="w-max flex md:items-center border-r-0 sm:border-r-[1px] gap-1 px-[1rem] leading-none svap1p1-details">
                    <h1 className="w-max svap1p1d-t1">Delivered at:</h1>
                    <h1 className="w-max  svap1p1d-t2 svap1p1d-t1">Lokmat</h1>
                  </div>
                </div>
                <div className="w-max flex items-center">
                  <div className="w-max flex md:items-center gap-1 pr-[1rem] sm:px-[1rem] leading-none svap1p1-details">
                    <h1 className="w-max svap1p1d-t1">Author:</h1>
                    <h1 className="w-max  svap1p1d-t2 svap1p1d-t1">
                      CA Umesh Sharma
                    </h1>
                  </div>
                  <div className="w-max flex md:items-center border-r-0 gap-1 px-[1rem] leading-none svap1p1-details">
                    <h1 className="w-max svap1p1d-t1">Last update</h1>
                    <h1 className="w-max svap1p1d-t2 svap1p1d-t1">
                      On 2 Jan 2021
                    </h1>
                  </div>
                </div>
              </div>
              <div className="mb-[5%]">
                <img
                  className="w-full"
                  src="media/img/workplace/workplace1.svg"
                  alt="GCC Law Help Workplace Image"
                />
              </div>
              <div className="flex flex-col gap-5">
                <p className="sva-para">
                  First, a disclaimer – the entire process of writing a blog
                  post often takes more than a couple of hours, even if you can
                  type eighty words per minute and your writing skills are
                  sharp. From the seed of the idea to finally hitting “Publish,”
                  you might spend several days or maybe even a week “writing” a
                  blog post, but it’s important to spend those vital hours
                  planning your post and even thinking about{" "}
                  <span className="sva-para-bold">Your Post</span> (yes,
                  thinking counts as working if you’re a blogger) before you
                  actually write it.
                </p>
                <p className="sva-para">
                  There’s an old maxim that states, “No fun for the writer, no
                  fun for the reader.” No matter what industry you’re working
                  in, as a blogger, you should live and die by this statement.
                </p>
                <p className="sva-para">
                  Before you do any of the following steps, be sure to pick a
                  topic that actually interests you. Nothing – and{" "}
                  <span className="sva-para-bold">I mean NOTHING</span> – will
                  kill a blog post more effectively than a lack of enthusiasm
                  from the writer. You can tell when a writer is bored by their
                  subject, and it’s so cringe-worthy it’s a little embarrassing.
                </p>
                <p className="sva-para">
                  I can hear your objections already. “But Dan, I have to blog
                  for a cardboard box manufacturing company.” I feel your pain,
                  I really do. During the course of my career, I’ve written
                  content for dozens of clients in some less-than-thrilling
                  industries (such as financial regulatory compliance and
                  corporate housing), but the hallmark of a professional blogger
                  is the ability to write well about any topic, no matter how
                  dry it may be. Blogging is a lot easier, however, if you can
                  muster at least a little enthusiasm for the topic at hand.
                </p>
              </div>
            </div>
            <div className="w-full svap1-part2">
              <h1 className="mb-[2%] sav1p2-title">Share by</h1>
              <div className="flex items-center gap-[2rem]">
                {/* <img
                  src={toAbsoluteUrl("media/img/icon/basic/facebook.svg")}
                  alt="GCC Law Facebook"
                />
                <img
                  src={toAbsoluteUrl("media/img/icon/basic/linkedin.jpg")}
                  alt="GCC Law linkedin"
                />
                <img
                  src={toAbsoluteUrl("media/img/icon/basic/whatsapp.jpg")}
                  alt="GCC Law Whatsapp"
                /> */}
                <a
                  href={`https://www.facebook.com/sharer/sharer.php?u=${shareLink}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    className="w-[2.5rem] h-[2.5rem]"
                    src={toAbsoluteUrl("media/img/icon/basic/facebook.svg")}
                    alt="GCC Law Facebook"
                  />
                </a>

                {/* LinkedIn Share */}
                <a
                  href={`https://www.linkedin.com/shareArticle?mini=true&url=${shareLink}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    className="w-[2.5rem] h-[2.5rem]"
                    src={toAbsoluteUrl(
                      "media/img/icon/social-media/Linkedin2.svg"
                    )}
                    alt="GCC Law LinkedIn"
                  />
                </a>

                {/* WhatsApp Share */}
                <a
                  href={`https://wa.me/?text=${shareLink}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    className="w-[3rem] h-[3rem]"
                    src={toAbsoluteUrl(
                      "media/img/icon/social-media/Whatsapp2.svg"
                    )}
                    alt="GCC Law WhatsApp"
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="w-full flex items-center justify-center">
          <button onClick={openModal} className="px-[5rem] py-[2rem] btn-leave">
            Leave reply
          </button>
        </div>
      </div>
    </>
  );
};

export default ViewArticleTwo;
